var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayerPause = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3841_1707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5633 23.209C45.5633 35.5521 35.5561 45.5583 23.2115 45.5583C10.8668 45.5583 0.859684 35.5521 0.859684 23.209C0.859684 10.8659 10.8668 0.859684 23.2115 0.859684C35.5561 0.859684 45.5633 10.8659 45.5633 23.209Z",
    stroke: "white",
    strokeWidth: 1.71937
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9 31.5584C20.9 31.9167 20.763 32.2602 20.5192 32.5135C20.2754 32.7668 19.9448 32.9091 19.6 32.9091H18.3C17.9552 32.9091 17.6246 32.7668 17.3808 32.5135C17.137 32.2602 17 31.9167 17 31.5584V15.3506C17 14.9924 17.137 14.6489 17.3808 14.3956C17.6246 14.1423 17.9552 14 18.3 14H19.6C19.9448 14 20.2754 14.1423 20.5192 14.3956C20.763 14.6489 20.9 14.9924 20.9 15.3506V31.5584ZM30 31.5584C30 31.9167 29.863 32.2602 29.6192 32.5135C29.3754 32.7668 29.0448 32.9091 28.7 32.9091H27.4C27.0552 32.9091 26.7246 32.7668 26.4808 32.5135C26.237 32.2602 26.1 31.9167 26.1 31.5584V15.3506C26.1 14.9924 26.237 14.6489 26.4808 14.3956C26.7246 14.1423 27.0552 14 27.4 14H28.7C29.0448 14 29.3754 14.1423 29.6192 14.3956C29.863 14.6489 30 14.9924 30 15.3506V31.5584Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3841_1707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.4229,
    height: 46.4179,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayerPause);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/player-pause.c7d172d5873cf905ba5d5b1d7e13f1bc.svg";